<template>
  <div class="cbg-white-container input-container theme--light v-card p-16 border-card">
    <div class="col-sm-12 row ml-0 pl-0 pr-0">
      <div class="row">
        <div class="form-group col-sm-6 col-md-3">
          <label for>Filter</label>
          <div class="position-relative search-div">
            <input
              type="text"
              placeholder="Search"
              class="form-control"
              v-model="search"
              @input="debounceSearch()"
            />

            <div v-if="search !== ''" class="search-svg position-absolute" @click="clearSearch()">
              <crossSVG />
            </div>
          </div>
        </div>
        <div class="form-group col-sm-6 col-md-3">
          <div class="position-relative">
            <label for>Status</label>
            <select name id class="form-control" v-model="ticketStatus" @change="getTicketList">
              <option value>All</option>
              <option value="pending">Pending</option>
              <option value="open">Open</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
              <option value="done">resolved</option>
            </select>
            <span class="drop-icon">
              <i aria-hidden="true" class="v-icon mdi mdi-menu-down theme--light position-absolute"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="table-div overflow-auto">
      <table class="table userlistTable table-width small-table-width userlistTable-typ1">
        <thead>
          <tr class="table-success">
            <th>Name</th>
            <th>Mobile</th>
            <th>Email</th>
            <th>Created Date</th>
            <th>Category</th>
            <th>Subject</th>
            <th>Ticket Status</th>
            <th>Team Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody v-for="(value, index) in ticketList" :key="index">
          <tr>
            <td class="capitalize-text">{{ value.user_name }}</td>
            <td>{{ value.mobile }}</td>
            <td>{{ value.email }}</td>
            <td>{{ getDate(value.created_at) }}</td>
            <td class="capitalize-text">{{ value.ticket_type }}</td>
            <td>{{ value.subject }}</td>
            <td class="capitalize-text">{{ value.user_status }}</td>
            <td class="capitalize-text">
              {{
              value.assigned_to[value.assigned_to.length - 1]
              .assigned_user_status
              }}
            </td>
            <!-- <td></td> -->
            <td class="py-2">
              <v-btn
                class="btn btn-primary"
                square
                size="sm"
                @click="toggleDetails(value, index)"
              >{{ Boolean(value._toggled) ? "Hide" : "Show" }}</v-btn>
            </td>
          </tr>
          <tr>
            <td colspan="9" class="p-0 border-0">
              <CCollapse
                :show="Boolean(value._toggled)"
                :duration="collapseDuration"
                class="col-sm-12"
              >
                <CCardBody class="col-sm-12">
                  <CRow class="seperate-bg pt-5 pb-5">
                    <v-btn
                      size="sm"
                      class="btn btn-primary ml-1"
                      @click="
                        history(value);
                        historyModal = true;
                      "
                      v-if="
                        permissions.includes(
                          'VIEW_HISTORY_CUSTOMER_TICKET_LIST'
                        )
                      "
                    >History</v-btn>
                    <v-btn
                      size="sm"
                      class="btn btn-primary ml-1"
                      @click="
                        descriptionVal(value);
                        informationDisplay = true;
                      "
                      v-if="
                        permissions.includes(
                          'VIEW_DESCRIPTION_CUSTOMER_TICKET_LIST'
                        )
                      "
                    >Description</v-btn>
                    <v-btn
                      size="sm"
                      class="btn btn-primary ml-1"
                      v-if="
                        value.imageval &&
                        permissions.includes(
                          'VIEW_ATTACHMENT_CUSTOMER_TICKET_LIST'
                        )
                      "
                      @click="viewAffidavit(value)"
                    >View Attachment</v-btn>
                  </CRow>
                  <CRow class="team-row-css">
                    <div class="col-sm-3 pb-0 pt-5" v-if="!value.is_visible">
                      <label for>Priority</label>
                      <select
                        name="priority"
                        id
                        class="form-control"
                        v-model="priority"
                        v-validate="'required'"
                      >
                        <option value>Select Priority</option>
                        <option value="low">Low</option>
                        <option value="medium">Medium</option>
                        <option value="high">High</option>
                      </select>
                      <span class="text-danger">{{ errors.first("priority") }}</span>
                    </div>
                    <div class="col-sm-3 pb-0 pt-5" v-else>
                      <h5>Priority</h5>
                      <h6 class="capitalize-text">{{ value.priority }}</h6>
                    </div>
                    <div class="col-sm-3 pt-5" v-if="!value.is_visible">
                      <label for>Teams</label>
                      <select
                        name="teams"
                        id
                        class="form-control"
                        v-model="teamNames"
                        @change="teamMembersList()"
                        v-validate="'required'"
                      >
                        <option value>Select Team</option>
                        <option value="technical">Technical</option>
                        <option value="support">Support</option>
                        <option value="accounts">Accounts</option>
                        <option value="business">Business</option>
                        <option value="others">Others</option>
                      </select>
                      <span class="text-danger">
                        {{
                        errors.first("teams")
                        }}
                      </span>
                    </div>
                    <div class="col-sm-3 pb-0 pt-5" v-else>
                      <h5>Team Name:</h5>
                      <h6 class="capitalize-text">
                        {{
                        value.assigned_to[value.assigned_to.length - 1]
                        .assigned_team
                        }}
                      </h6>
                    </div>

                    <div class="col-sm-3 pb-0 pt-5">
                      <div class="col-sm-12 p-0">
                        <label for>Remark</label>
                        <textarea
                          type="text"
                          placeholder="remark"
                          class="form-control"
                          v-model="value.admin_remarks"
                        />
                      </div>
                    </div>
                    <!-- <div class="col-sm-3" v-if="!value.is_visible">
                      <div class="col-sm-12 p-0" v-if="teamNames">
                        <label for>Team Members</label>
                        <select
                          name="member"
                          id
                          class="form-control"
                          v-model="teamMembers"
                          v-validate="'required'"
                        >
                          <option
                            v-for="(member, i) in memberList"
                            :key="i"
                            :value="member._id"
                          >{{ member.first_name + " " + member.last_name }}</option>
                        </select>
                        <span class="text-danger">{{ errors.first("member") }}</span>
                      </div>
                    </div>
                    <div class="col-sm-3 pb-0 pt-5" v-else>
                      <h5>Team Member:</h5>
                      <h6>
                        {{
                        value.assigned_to[value.assigned_to.length - 1]
                        .assigned_member
                        }}
                      </h6>
                    </div>-->
                    <div class="col-sm-3 d-flex justify-content-end align-items-center">
                      <!-- <span
                        v-if="
                          permissions.includes(
                            'CAN_SUBMIT_CUSTOMER_TICKET_LIST'
                          )
                        "
                      >
                        <v-btn
                          size="sm"
                          class="btn btn-success mt-6"
                          v-if="!value.is_visible"
                          @click="assignTo(value)"
                          >Submit</v-btn
                        >
                      </span>-->
                      <span
                        v-if="
                          permissions.includes(
                            'CAN_RESOLVE_CUSTOMER_TICKET_LIST'
                          )
                        "
                      >
                        <v-btn
                          size="sm"
                          class="btn btn-warning mt-6 ml-2"
                          v-if="
                            (value.ticket_type === 'query' ||
                              value.ticket_type === 'complaint') &&
                            value.user_status === 'pending'
                          "
                          @click="assignTo(value._id,value.admin_remarks)"
                        >resolved</v-btn>
                      </span>
                    </div>
                  </CRow>

                  <div>
                    <CModal
                      color="dark"
                      :show.sync="informationDisplay"
                      :no-close-on-backdrop="true"
                    >
                      <div class="col-sm-12">
                        <h6>{{ description }}</h6>
                      </div>
                      <template #header>
                        <h6 class="modal-title">Description</h6>
                      </template>
                      <template #footer>
                        <v-btn @click="informationDisplay = false" class="btn btn-danger">Cancel</v-btn>
                      </template>
                    </CModal>
                    <CModal
                      :show.sync="affidavitModal"
                      :no-close-on-backdrop="true"
                      :centered="true"
                      title="Modal title 2"
                      size="lg"
                      color="dark"
                      :details="affidavitData"
                    >
                      <CImg
                        v-if="
                          typeOfDocument == 'png' ||
                          typeOfDocument == 'jpeg' ||
                          typeOfDocument == 'jpg' ||
                          typeOfDocument == 'webp'
                        "
                        :src="affidavitData.imageval"
                        block
                        class="mb-2"
                        width="470"
                        height="600"
                      />
                      <embed
                        v-else-if="typeOfDocument == 'pdf'"
                        :src="src"
                        style="width: 100%; height: 800px"
                      />
                      <template #header>
                        <h6 class="modal-title">Affidavit</h6>
                        <!-- <CButtonClose @click="affidavitModal = false" /> -->
                      </template>
                      <template #footer>
                        <v-btn @click="affidavitModal = false" class="btn btn-danger">Cancel</v-btn>
                      </template>
                    </CModal>
                  </div>
                </CCardBody>
              </CCollapse>
            </td>
          </tr>
        </tbody>
        <tbody v-if="ticketList.length <= 0">
          <tr>
            <td colspan="9">
              <h2 class="text-center">No Data Found</h2>
            </td>
          </tr>
        </tbody>
        <loader v-if="showLoader"></loader>
      </table>
    </div>
    <CModal
      :show.sync="historyModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="History"
      size="lg"
      color="dark"
      :details="logList"
    >
      <div class="col-sm-12" v-if="logList && logList.length">
        <p>
          {{ logCreatedBy.full_name }} Created ticket on
          {{ getDate(logCreatedAt) }}
        </p>
        <div class="form-group" v-for="(log, index) in logList" :key="index">
          <p v-if="log.assigned_member && log.assigned_user_status == 'pending'">
            Admin assigned ticket to {{ log.assigned_member }} on
            {{ getDate(log.assigned_date) }}.
          </p>
          <p v-if="log.assigned_member && log.assigned_user_status == 'rejected'">
            {{ log.assigned_member }} reassign this ticket to admin on
            {{ getDate(log.assigned_date) }}.
          </p>
          <p v-if="log.assigned_member && log.assigned_user_status == 'accepted'">
            {{ log.assigned_member }} accepted this ticket on
            {{ getDate(log.assigned_date) }}.
          </p>
          <p v-if="log.assigned_member && log.assigned_user_status == 'done'">
            {{ log.assigned_member }} resolved this ticket on
            {{ getDate(log.assigned_date) }}.
          </p>
          <p v-if="log.assigned_member && log.assigned_user_status == 'declined'">
            {{ log.assigned_member }} declined this ticket on
            {{ getDate(log.assigned_date) }}.
          </p>
          <div class="row">
            <hr />
          </div>
        </div>
      </div>
      <template #header class="bg-white">
        <h6 class="modal-title">History</h6>
        <!-- <CButtonClose @click="historyModal = false" /> -->
      </template>
      <template #footer>
        <v-btn @click="historyModal = false" class="btn btn-danger">Cancel</v-btn>
      </template>
    </CModal>
    <pagination
      class="pagination-block"
      :recordPerPage="recordPerPage"
      :currentPage="currentPage"
      :total="total"
      @changePage="changePage"
    />
  </div>
</template>

<script>
import { pickSvg } from "@/views/SVG";
import { mapGetters } from "vuex";
import config from "@/config.js";
import debounce from "lodash/debounce";
const loader = () => import("@/components/loader.vue");
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();

export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {
    loader,
    ...pickSvg("crossSVG"),
    pagination: () => import("@/views/common/Pagination")
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  name: "AdvancedTables",
  data() {
    return {
      dayJS,
      ticketStatus: "",
      details: [],
      collapseDuration: 0,
      ticketList: [],
      val: "",
      collaps: false,
      priority: "",
      teamNames: "",
      teamMembers: "",
      informationDisplay: false,
      affidavitModal: false,
      affidavitData: {},
      typeOfDocument: "",
      src: "",
      remark: "",
      memberList: [],
      fullName: "",
      currentPage: 1,
      totalPage: 1,
      recordPerPage: 10,
      historyModal: false,
      logList: [],
      logCreatedBy: {},
      description: "",
      search: "",
      showLoader: false,
      total: 0
    };
  },
  mounted() {
    this.getTicketList();
  },

  methods: {
    getResolved(userId) {
      let url = `${config.BASE_URL}api/v2/admin/tickets/${userId}/resolve`;
      this.$http.post(url).then(response => {
        if (response.body.status) {
          this.$swal({
            text: "Resolved Sucessfully",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "Ok"
          });
          this.getTicketList();
        }
      });
    },
    clearSearch() {
      this.search = "";
    },
    getDate(date) {
      return dayJS(date).format("DD-MM-YYYY h:mm A");
    },
    viewAffidavit(item) {
      this.affidavitModal = true;
      let fileDetails = item && item.imageval.split(".");
      this.typeOfDocument = fileDetails[fileDetails.length - 1];
      this.src = item.imageval;
      this.affidavitData = item;
    },
    changePage(page) {
      this.currentPage = page.currentPage;
      this.getTicketList();
    },
    debounceSearch: debounce(function() {
      this.getTicketList();
    }, 500),
    getTicketList() {
      this.showLoader = true;
      let arr = [];
      let params = { search: this.search };
      if (this.ticketStatus != "") {
        params.ticket_status = this.ticketStatus;
      }
      let url = `${config.BASE_URL}api/v2/admin/ticket/listing/${this.currentPage}/${this.recordPerPage}`;
      this.$http.get(url, { params }).then(response => {
        if (response.body.status) {
          this.showLoader = false;
          this.ticketList = response.body.data.list;
          this.totalPage = Math.ceil(response.body.data.count / 10);
          this.total = response.body.data.count;
        } else {
          this.showLoader = false;
        }
      });
    },
    toggleDetails(item, index) {
      this.$set(this.ticketList[index], "_toggled", !item._toggled);
      this.collapseDuration = 300;
      this.remark = "";
      this.priority = "";
      this.teamNames = "";
      this.$validator.reset();
      this.$nextTick(() => {
        this.collapseDuration = 0;
      });
    },
    teamMembersList() {
      let url = `${config.BASE_URL}api/v2/admin/login/user/team/${this.teamNames}`;
      this.$http.get(url).then(response => {
        if (response.body.status) {
          this.memberList = [...response.body.data];
        }
      });
    },
    assignTo(ticket_id, remark) {
      // this.fullName = "";
      // for (let i in this.memberList) {
      //   if (this.memberList[i]._id == this.teamMembers) {
      //     this.fullName =
      //       this.memberList[i].first_name + " " + this.memberList[i].last_name;
      //   }
      // }
      this.$validator.validate().then(valid => {
        if (valid) {
          let obj = {
            ticket_id: ticket_id,
            assigned_team: this.teamNames,
            // assigned_id: this.teamMembers,
            // assigned_member: this.fullName,
            // assigned_user_status: item.assigned_to.assigned_user_status,
            remark: remark,
            priority: this.priority
          };
          let url = `${config.BASE_URL}api/v2/admin/ticket/status/update`;
          this.$http.post(url, obj).then(response => {
            if (response.body.status) {
              this.getTicketList();
            }
          });
        }
      });
    },
    history(item) {
      let id = item._id;
      let url = `${config.BASE_URL}api/v2/admin/ticket/history/${id}`;
      this.$http.get(url).then(response => {
        if (response.body.status) {
          this.logList = response.body.data.assigned_to;
          this.logCreatedBy = response.body.data.created_by;
          this.logCreatedAt = item.created_at;
        }
      });
    },
    descriptionVal(item) {
      this.description = item.description;
    }
  }
};
</script>
<style lang="scss" scoped>
.capitalize-text {
  text-transform: capitalize;
}
.text-danger {
  font-size: 0.7vw;
}
</style>
